import { defineEnum } from '@nzyme/utils/defineEnum.js';
export const Environment = defineEnum([
    /** Local development environment */
    'dev',
    /** Production environment */
    'prod',
    /** Testing environment */
    'testing',
    /** Demo environment */
    'demo',
    /** Developer tooling environment */
    'devx',
    /** Local environment using LocalStack */
    'local',
]);
export const USERNAME = String(process.env.USERNAME);
export const ENV = getEnv();
export const ENV_BASE = getEnvBase(ENV);
export const ENV_LOCAL = getEnvLocal();
export const GIT_BRANCH = getBranch();
export const PRODUCTION = ENV === 'prod';
export const LOCAL = ENV === 'dev' || ENV === 'local';
export const E2E = LOCAL;
export const TESTING = ENV === 'testing';
export const DEMO = ENV === 'demo';
export const DEVX = ENV === 'devx';
export const LOCALSTACK = ENV === 'local';
export const NON_DEV = !LOCAL && !DEVX;
export const WORKTREE_NAME = ENV === 'local' ? process.env.WORKTREE_NAME || 'sigma' : 'sigma';
export const WORKTREE_PORT = ENV === 'local' ? Number(process.env.WORKTREE_PORT) || 3000 : 3000;
export function assertEnvironment(env) {
    if (!Environment.includes(env)) {
        throw new Error(`Unknown environment: ${env}.`);
    }
}
/**
 * Returns the base environment name for the given environment.
 * This way we can have multiple environments deriving configuration from the same base environment.
 * For example, we can have a demo environment that derives configuration from the testing environment.
 *
 * Takes the environment as a parameter rather than reading {@link ENV}: the two non-identity
 * mappings below decide which AWS account and which secrets an environment resolves to, and a
 * function closed over a module-load constant can only ever be tested for whichever `ENV` the test
 * process happens to run under.
 * @__NO_SIDE_EFFECTS__
 */
export function getEnvBase(env) {
    switch (env) {
        case 'demo':
            return 'testing';
        case 'local':
            return 'dev';
        default:
            return env;
    }
}
function getEnv() {
    if (process.env.ENV) {
        return process.env.ENV;
    }
    if (process.env.NODE_ENV === 'test') {
        return 'local';
    }
    return 'dev';
}
function getEnvLocal() {
    switch (ENV) {
        case 'dev':
            return `dev:${USERNAME}`;
        case 'local':
            return `local`;
        default:
            return ENV;
    }
}
function getBranch() {
    switch (ENV) {
        case 'demo':
        case 'prod':
            return 'release';
        case 'dev':
        case 'local':
            return null;
        default:
            return 'main';
    }
}
//# sourceMappingURL=environments.js.map